import { CloudCode } from './cloudcode';

export interface PayInvoiceParams {
  invoiceRequestID: string
  customerID: string
}

export class InvoiceTasks {

  static payInvoice(
    params: PayInvoiceParams,
    successCallback: () => void,
    errorCallback: (msg: string) => void) {

    CloudCode.run('payInvoice', 
      params,
      () => {
        successCallback();
      }, 
      (msg: string) => {
        errorCallback(msg);
      });
  }
  
}